<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	* {
		padding: 0px;
		margin: 0px;
	}

	.el-dialog__body {
		padding: 10px;
	}

	a {
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue